import { ADMIN_ROLE_ID, VIEWER_ROLE_ID } from "./AccountConstants";

export const GetRoleId = (): number => {
  const roleId = localStorage.getItem("role_id");
  return roleId ? parseInt(roleId, 10) : 0;
};

export const IsAdminRole = (roleId = GetRoleId()): boolean =>
  roleId === ADMIN_ROLE_ID;

export const IsViewerRole = (roleId = GetRoleId()): boolean =>
  roleId === VIEWER_ROLE_ID;
